export default "__VITE_ASSET__hrVcLP4C__"